import { toast, loading } from '@/shared/utils/UIHelper'

import { EVENT_NAME_BEFORE_LOAD, EVENT_NAME_AFTER_LOAD } from '../constants/events'

export const usePageMixin = {
  props: {
    itemKey: {
      type: String,
      required: true
    },
    load: {
      type: Function,
      default: () => {},
      required: true
    },
    loadRelated: {
      type: Function,
      default: () => {},
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      pageIndex: 1,
      totalPages: 0,
      data: []
    }
  },
  beforeMount () {
    this.handleLoad(this.internalLoad)
  },
  methods: {
    async handleLoad (load) {
      if (!this.isLoading) {
        loading.push()
        this.isLoading = true

        if (this.hasOwnProperty(EVENT_NAME_BEFORE_LOAD)) this[EVENT_NAME_BEFORE_LOAD]()

        const data = await load()

        this.data = data

        this.isLoading = false
        loading.pop()

        if (this.hasOwnProperty(EVENT_NAME_AFTER_LOAD)) this.$nextTick(() => this[EVENT_NAME_AFTER_LOAD]())
      }
    },
    async internalLoad () {
      const data = await this.load()
        .then(response => {
          const { code, data } = response.data

          if (code === 200) {
            return data.map(item => ({
              ...item,
              _deep: 0,
              _parentId: null,
              _expanded: false
            }))
          }

          return []
        })
        .catch(() => {
          toast.error(this.$lang.Common.MicroserviceUnavailable)

          return []
        })

      return data
    },
    async internalLoadRelated (parent, deep) {
      const data = await this.loadRelated(parent)
        .then(response => {
          const { code, data } = response.data

          if (code === 200) {
            return data.map(item => ({
              ...item,
              _deep: deep,
              _parentId: parent[this.itemKey],
              _expanded: false
            }))
          }

          return []
        })
        .catch(() => {
          toast.error(this.$lang.Common.MicroserviceUnavailable)

          return []
        })

      return data
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/treegrid/mixins/usePageMixin.js